import * as React from 'react'

import { Box, Icon, InputCheckBox, Table, Text } from '@factorialco/deprecated-design-system'
import isEqual from 'lodash/isEqual'

import { observer } from 'mobx-react'

import type FiltersForm from 'modules/core/lib/forms/Filters'
import i18n from 'modules/core/lib/i18n'

import SupplementTypeLabel from 'modules/payroll_bundle/components/common/components/SupplementTypeLabel'
import type { SupplementType } from 'modules/payroll_bundle/components/common/helper/worksheet'
import { Actions } from 'modules/payroll_bundle/lib/bulkImportSupplementsContext'
import { UPDATE_DATA } from 'modules/payroll_bundle/lib/constants'

import SortableHeader from './SortableHeader'

interface Props {
  checkable?: boolean
  supplementTypes: SupplementType[]
  supplementTypesWithErrorRows: Set<string>
  selectable?: Array<string | null>
  onSelectAll?: () => void
  selected?: Set<string>
  filtersForm: FiltersForm
  supplementDispatch: React.Dispatch<Actions>
}

const Header = ({
  checkable,
  supplementTypes,
  supplementTypesWithErrorRows,
  selected,
  selectable,
  filtersForm,
  onSelectAll,
  supplementDispatch,
}: Props) => {
  const openAssignModal = (supplementType: SupplementType) => {
    supplementDispatch({
      type: UPDATE_DATA,
      payload: {
        showAssignTypeModal: true,
        editingSupplementType: supplementType,
      },
    })
  }

  const TableCheckBox = () => {
    return (
      <InputCheckBox
        label={i18n.t('common.select_all')}
        checked={
          !!selected && selected.size !== 0 && isEqual([...selected].sort(), selectable?.sort())
        }
        onClick={onSelectAll}
      />
    )
  }

  return (
    <Table.Head>
      <Table.Row>
        {checkable && selected && <Table.HeadCell width={50} left={<TableCheckBox />} />}
        <SortableHeader filtersForm={filtersForm} attribute="full_name" width={400}>
          <Text size="200" color="grey800" weight="semibold">
            {i18n.t('payroll_bundle.supplements.bulk_import.table.header.uploaded_name')}
          </Text>{' '}
        </SortableHeader>
        {supplementTypes.map((supplementType) => (
          <SortableHeader
            key={supplementType.id}
            filtersForm={filtersForm}
            attribute={supplementType.id}
            width={180}
            left={
              <Box
                flexDirection="row"
                onClick={() => openAssignModal(supplementType)}
                cursor="pointer"
              >
                <SupplementTypeLabel
                  supplementType={supplementType}
                  color={
                    supplementTypesWithErrorRows.has(supplementType.id)
                      ? 'radicalRed1200'
                      : undefined
                  }
                />
                <Icon.Medium icon="pencil" />
              </Box>
            }
          />
        ))}
        <Table.HeadCell width={336} padding="s0">
          <Box
            paddingX="s24"
            paddingY="s16"
            border={{
              left: {
                width: 's1',
                style: 'solid',
                color: 'grey400',
              },
            }}
            height="full"
          ></Box>
        </Table.HeadCell>
      </Table.Row>
    </Table.Head>
  )
}

export default observer(Header)
